<template>
  <div ref="scrollContainer" class="rounded" :class="{ 'student-bookings-mobile': $vuetify.breakpoint.mobile }"
    :style="wrapperStyle" @scroll="onScroll">
    <v-tabs fixed-tabs background-color="primary-gradient" dark class="mb-4 rounded" v-model="timeTab"
      style="position: sticky; top: 0; z-index: 1">
      <v-tab class="font-weight-bold">{{ notification ? "Approved" : "Upcoming" }}
      </v-tab>
      <v-tab class="font-weight-bold">{{ notification ? "Others" : "Past" }}
      </v-tab>
    </v-tabs>

    <v-card class="my-5" v-if="!notification">
      <v-card-text class="pb-2">
        <v-btn class="mr-2 mb-2" :class="{
          'primary--text v-chip-active': status === value,
        }" v-for="value in [
          'All',
          'Declined',
          'Pending',
          'Finished',
          'Approved',
        ]" :key="value" @click="status = value; runSearch()" small>
          {{ value }}
        </v-btn>
      </v-card-text>
    </v-card>
    <div v-if="notification && timeTab === 1">
      <template v-for="(item, index) in notifications">
        <v-card class="mb-5" :key="index">
          <v-card-text>
            <strong>{{ item.school }}</strong> has rescheduled your appointment
            on <strong>{{ item.date }}</strong> with
            <strong>{{ item.instructor }}</strong>
          </v-card-text>
        </v-card>
      </template>
    </div>
    <template v-else>
      <List v-if="dashboardView === 'list'" :loading="loading" :headers="headers" :appointments="filteredAppointments"
        :getColor="getColor" :showDialog="showDialog" />
      <Calendar v-if="dashboardView === 'calendar'" :loading="loading" :appointments="filteredAppointments"
        :getColor="getColor" :showDialog="showDialog" />
      <Card v-if="dashboardView === 'card'" :loading="loading" :headers="headers" :appointments="filteredAppointments"
        :getColor="getColor" :showDialog="showDialog" />
      <div ref="loadMoreSentinel" v-if="hasMore && !loading" class="text-center py-3">
        <v-btn v-if="!loadingMore" small outlined @click="loadMore">Load more</v-btn>
        <v-progress-circular v-else indeterminate size="24" />
      </div>
    </template>

    <v-dialog v-model="dialog" persistent max-width="375" v-if="appointment">
      <v-card>
        <v-card-text class="pt-5">
          <div class="d-flex align-center">
            <v-avatar size="70" v-if="appointment.profilePicture">
              <img :src="appointment.profilePicture" />
            </v-avatar>
            <v-avatar size="70" v-else>
              <img src="https://thedriverx.com/assets/images/user.png" />
            </v-avatar>
            <div>
              <v-chip x-small dark :color="appointment.color" class="ml-4">{{
                appointment.status
              }}</v-chip>
              <v-card-title class="headline py-0">{{
                appointment.name
              }}</v-card-title>
              <div class="ml-3">
                <v-chip x-small color="warning" class="ml-1" v-if="
                  appointment.type[0] === 'roadtest_rent_car' ||
                  appointment.type[0] === 'rentcar_n_lesson'
                ">
                  Road Test
                </v-chip>
                <v-chip x-small color="success" class="ml-1" v-if="
                  appointment.type[0] === 'booking_lesson' ||
                  appointment.type[0] === 'rentcar_n_lesson'
                ">
                  Lesson
                </v-chip>
              </div>
            </div>
          </div>
          <v-row align="end">
            <v-col>
              <p class="mb-0" v-if="userType === 'instructor'">
                <strong>Duration:</strong>
                {{
                  $moment
                    .duration(
                      $moment(appointment.end).diff($moment(appointment.start))
                    )
                    .asHours()
                }}hr
              </p>
              <p class="mb-0">
                <!--<strong>Location:</strong> {{ appointment.location }}!-->
              </p>
              <div class="d-flex mt-4">
                <v-btn outlined fab dark small color="primary" :href="`mailto:${appointment.instructorEmail}`">
                  <v-icon dark> mdi-email </v-icon>
                </v-btn>
                <v-btn class="ml-2" outlined fab dark small color="primary" :href="`tel:${appointment.phone}`">
                  <v-icon dark> mdi-phone </v-icon>
                </v-btn>
                <v-btn class="ml-2" outlined fab dark small color="primary" :to="`/chat/${appointment.instructorId}`">
                  <v-icon dark> mdi-chat </v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="auto" v-if="
              appointment.status === 'Approved' ||
              !appointment.drivingLessonDates.length
            ">
              <v-btn v-if="isRealMobileDevice" color="warning" text block x-small @click="addToCalendar" class="mb-1">
                <v-icon>mdi-calendar-plus</v-icon>
              </v-btn>

              <Day :date="appointment.start" />
            </v-col>
            <v-col cols="12" v-if="appointment.roadtestOptions || appointment.roadtestOptions">
              <v-expansion-panels>
                <v-expansion-panel v-if="appointment.learningOptions">
                  <v-expansion-panel-header>
                    Learning Options
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    {{ appointment.learningOptions }}
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="appointment.roadtestOptions">
                  <v-expansion-panel-header>
                    Roadtest Options
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <template v-if="appointment.roadtestOptions === 'mockRoadTestG'">
                      Overview of all the basic driving skills, behaviors and
                      knowledge needed to pass the G driving exam. Includes an
                      overview of highway driving.
                    </template>
                    <template v-if="appointment.roadtestOptions === 'mockRoadTestG2'">
                      Overview of all the basic driving skills, behaviors and
                      knowledge needed to pass the G2 driving exam. Does not
                      include highway driving.
                    </template>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <template v-if="!!appointment.notes">
                <h4 class="mt-2">Notes</h4>
                <p class="mb-0">{{ appointment.notes }}</p>
              </template>
            </v-col>
            <v-col cols="12" class="text-center" v-if="
              appointment.status === 'Pending' &&
              appointment.drivingLessonDates.length
            ">
              <h4 class="mb-2">Please choose from below</h4>
              <select-day :dates="appointment.drivingLessonDates.map(
                ({ start }) => new Date(start)
              )
                " :activeDate="selectedAppointmentDate" @update:date="selectedAppointmentDate = $event" />
            </v-col>
            <!-- Loader while fetching feedback for Finished bookings -->
            <v-col cols="12" v-if="appointment.status === 'Finished' && loadingFeedback" class="pt-2">
              <div class="feedback-loading pa-3 rounded text-center" style="background: #f5f5f5;">
                <v-progress-circular indeterminate color="primary" size="32" width="3" class="mb-2" />
                <div class="caption grey--text">Loading feedback...</div>
              </div>
            </v-col>
            <!-- Show submitted feedback for Finished bookings that already have feedback -->
            <v-col cols="12" v-else-if="appointment.status === 'Finished' && currentAppointmentReview" class="pt-2">
              <div class="feedback-summary pa-3 rounded" style="background: #f5f5f5;">
                <div class="subtitle-2 grey--text text--darken-1 mb-2">Your feedback</div>
                <v-rating :value="currentAppointmentReview.star" color="warning" background-color="warning"
                  half-increments dense size="22" readonly class="mb-2" />
                <p v-if="currentAppointmentReview.review" class="mb-0 body-2">{{ currentAppointmentReview.review }}</p>
                <div v-if="currentAppointmentReview.studentSignature" class="mt-2">
                  <div class="caption grey--text mb-1">Your signature</div>
                  <img :src="currentAppointmentReview.studentSignature" alt="Your signature"
                    class="feedback-signature-img" />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-5 pt-0">
          <v-btn small @click="
            dialog = false;
          selectedAppointmentDate = null;
          ">
            Close
          </v-btn>
          <v-spacer />
          <v-btn small color="success" class="white--text" @click="
            dialog = false;
          confirm = true;
          " :disabled="appointment.status !== 'Approved'" v-if="
            appointment.status === 'Pending' ||
            appointment.status === 'Approved'
          ">
            Reschedule
          </v-btn>

          <v-btn small color="primary" @click="approveEvent" v-if="appointment.status === 'Pending'" :disabled="!!appointment.drivingLessonDates.length &&
            !selectedAppointmentDate
            ">
            Approve
          </v-btn>
          <v-btn small color="warning" @click="
            makeComplete = true;
          ifRatingSavedBefore();
          " v-if="appointment.status === 'Finished' && !currentAppointmentReview && !loadingFeedback">
            Rate this
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirm" persistent max-width="300">
      <v-card>
        <v-card-title class="headline"> Warning! </v-card-title>
        <v-card-text class="pb-0">
          Are you sure you want to reschedule this event? Current appointment
          will be removed if you select 'Yes'
          <v-textarea outlined label="Notes" v-model="rescheduleEventNotes" class="mt-4 pb-0 mb-0"
            placeholder="Note: You may add next available date/time you are available" dense />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" small text @click="confirm = false">
            No
          </v-btn>
          <v-btn color="red darken-1" small text @click="rescheduleEvent">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="makeComplete" max-width="420" @click:outside="closeRateDialog">
      <v-card class="student-rate-card text-center">
        <v-card-title class="headline justify-center primary--text py-3 d-flex align-center">
          <span class="flex-grow-1">Please Rate</span>
          <v-btn icon small @click="closeRateDialog" aria-label="Close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          <v-rating v-model="rating" color="warning" background-color="warning" half-increments dense size="32"
            class="mb-2" />
          <v-textarea outlined label="Add Comments" v-model="ratingFeedback" class="mt-0 pb-0 mb-2" dense rows="2" />
          <!-- Student signature -->
          <div class="signature-section mt-3 signature-pad-wrapper">
            <p class="caption mb-1 text-left font-weight-medium grey--text text--darken-1">
              Your signature
            </p>
            <VueSignaturePad ref="studentSignaturePad" class="student-signature-pad" width="100%" height="140px"
              :options="studentSignatureOptions" />
            <div class="d-flex justify-space-between align-center mt-1">
              <v-btn x-small text color="grey" @click="undoStudentSignature">
                Undo
              </v-btn>
            </div>
          </div>
          <v-btn block large color="primary" class="mt-4" :disabled="!canSubmitStudentRate" :loading="loading"
            @click="completeEvent">
            Submit
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VueSignaturePad } from 'vue-signature-pad'
import Calendar from '@/components/dashboard/Calendar'
import Card from '@/components/dashboard/Card'
import List from '@/components/dashboard/List'
import Day from '@/components/common/Day'
import SelectDay from '@/components/common/SelectDay'
import { mapGetters, mapActions } from 'vuex'
import { iPhoneVersion, isIphone } from '../../utils'

export default {
  props: {
    notification: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueSignaturePad,
    Calendar,
    Card,
    List,
    Day,
    SelectDay
  },
  data() {
    return {
      loading: false,
      dialog: false,
      confirm: false,
      rescheduleEventNotes: '',
      appointment: null,
      selectedAppointmentDate: null,
      timeTab: null,
      headers: [
        { text: 'Name', align: 'start', value: 'name' },
        { text: 'Start', value: 'start' },
        { text: 'End', value: 'end' },
        { text: 'Email', value: 'instructorEmail' },
        { text: 'Location', value: 'location' },
        { text: 'Status', align: 'end', value: 'status' }
      ],
      appointments: [],
      notifications: [],
      makeComplete: false,
      rating: 0,
      ratingFeedback: '',
      studentSignatureSigned: false,
      studentSignatureEmpty: true,
      studentSignatureOptions: {},
      signatureCheckInterval: null,
      currentAppointmentReview: null,
      loadingFeedback: false,
      status: 'All',
      isRealMobileDevice: typeof window.cordova !== 'undefined',
      pageSize: 5,
      loadingMore: false,
      hasMore: true,
      totalAppointmentsCount: null
    }
  },
  computed: {
    ...mapGetters([
      'dashboardView',
      'user',
      'studentAppointments',
      'rescheduleAppment',
      'rescheduleFromAdmin',
      'checkReview',
      'reviewRatings'
    ]),
    wrapperStyle() {
      const mobile = this.$vuetify.breakpoint.mobile
      if (mobile) {
        return { position: 'relative', overflow: 'auto' }
      }
      const height = 92 + (this.isIphone10Avobe() ? 34 : 0)
      return {
        position: 'relative',
        overflow: 'auto',
        height: `calc(100vh - ${height}px)`
      }
    },
    filteredAppointments: {
      get() {
        return this.appointments.filter(({ start }) => {
          if (this.timeTab) {
            return this.$moment(start).isBefore(this.$moment(), 'day')
          }
          return this.$moment(start).isSameOrAfter(this.$moment(), 'day')
        })
      },
      set(val) {
        this.appointments = val
      }
    },
    canSubmitStudentRate() {
      if (!this.rating) return false
      const pad = this.$refs.studentSignaturePad
      if (pad && !pad.isEmpty()) return true
      return this.studentSignatureSigned && !this.studentSignatureEmpty
    }
  },
  watch: {
    async dialog(isOpen) {
      if (isOpen && this.appointment && this.appointment.status === 'Finished') {
        this.currentAppointmentReview = null
        this.loadingFeedback = true
        try {
          await this.checkReviewRatings({
            reviewFrom: this.user.id,
            reviewFor: this.appointment.instructorId,
            appointmentId: this.appointment.appointmentId
          })
          if (this.checkReview) {
            this.currentAppointmentReview = {
              star: this.checkReview.get('star'),
              review: this.checkReview.get('review') || '',
              studentSignature: this.checkReview.get('studentSignature') || null
            }
          }
        } finally {
          this.loadingFeedback = false
        }
      } else if (!isOpen) {
        this.currentAppointmentReview = null
        this.loadingFeedback = false
      }
    },
    makeComplete(isOpen) {
      if (isOpen) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.onStudentRateDialogOpen(true)
          })
        })
        this.startSignatureCheckInterval()
      } else {
        this.stopSignatureCheckInterval()
      }
    },
    // timeTab(val) {
    //   this.filteredAppointments = this.appointments.filter((appointment) => {
    //     if (this.notification) {
    //       return val
    //         ? false
    //         : appointment.status === 'Approved' &&
    //         !this.$moment(appointment.end).isBefore(this.$moment())
    //     }
    //     return val
    //       ? this.$moment(appointment.end).isBefore(this.$moment())
    //       : !this.$moment(appointment.end).isBefore(this.$moment())
    //   })
    // }
  },
  methods: {
    ...mapActions([
      'toggleDialog',
      'getStudentAppointments',
      'updateUser',
      'rescheduleAppointment',
      'getRescheduleFromAdmin',
      'checkReviewRatings',
      'saveReviewRatings',
      'sendPushNotification'
    ]),
    isIphone10Avobe() {
      return (
        isIphone() &&
        ['iPhone-X-Xs', 'iPhone-Xmax-Xr', 'iPhone-12'].includes(iPhoneVersion())
      )
    },
    closeRateDialog() {
      this.makeComplete = false
    },
    startSignatureCheckInterval() {
      this.stopSignatureCheckInterval()
      this.signatureCheckInterval = setInterval(() => {
        if (this.makeComplete && this.$refs.studentSignaturePad) {
          this.checkStudentSignature()
        }
      }, 350)
    },
    stopSignatureCheckInterval() {
      if (this.signatureCheckInterval) {
        clearInterval(this.signatureCheckInterval)
        this.signatureCheckInterval = null
      }
    },
    onStudentRateDialogOpen() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          const pad = this.$refs.studentSignaturePad
          if (pad) {
            pad.clearSignature()
            setTimeout(() => {
              if (pad.resizeCanvas) {
                pad.resizeCanvas()
              }
            }, 100)
          }
          this.studentSignatureSigned = false
          this.studentSignatureEmpty = true
        })
      })
    },
    checkStudentSignature() {
      const pad = this.$refs.studentSignaturePad
      if (!pad) return
      this.studentSignatureEmpty = pad.isEmpty()
    },
    undoStudentSignature() {
      const pad = this.$refs.studentSignaturePad
      if (pad) {
        pad.undoSignature()
        this.checkStudentSignature()
      }
    },
    async ifRatingSavedBefore() {
      if (this.appointment.appointmentId) {
        /** First check if the  */
        await this.checkReviewRatings({
          reviewFrom: this.user.id,
          reviewFor: this.appointment.instructorId,
          appointmentId: this.appointment.appointmentId
        })
        if (this.checkReview) {
          this.rating = this.checkReview.get('star')
          this.ratingFeedback = this.checkReview.get('review')
        }
      }
    },
    async completeEvent() {
      if (this.appointment.appointmentId) {
        const signaturePad = this.$refs.studentSignaturePad
        const signatureData = signaturePad && !signaturePad.isEmpty()
          ? signaturePad.saveSignature().data
          : null

        this.loading = true
        this.makeComplete = false
        this.dialog = false
        /** First check if the review already saved */
        await this.checkReviewRatings({
          reviewFrom: this.user.id,
          reviewFor: this.appointment.instructorId,
          appointmentId: this.appointment.appointmentId
        })
        if (this.checkReview) {
          await this.saveReviewRatings({
            appointmentId: this.appointment.appointmentId,
            reviewFrom: this.user.id,
            reviewFor: this.appointment.instructorId,
            star: Number(this.rating),
            review: this.ratingFeedback,
            studentSignature: signatureData,
            reviewId: this.checkReview.id
          })
        } else {
          await this.saveReviewRatings({
            appointmentId: this.appointment.appointmentId,
            reviewFrom: this.user.id,
            reviewFor: this.appointment.instructorId,
            star: Number(this.rating),
            review: this.ratingFeedback,
            studentSignature: signatureData
          })
        }
        this.loading = false
        if (this.reviewRatings) {
          this.toggleDialog({
            status: true,
            title: 'Success!',
            message: 'Thank you! Your feedback has been saved.'
          })
          this.rating = 0
          this.ratingFeedback = ''
          this.studentSignatureSigned = false
          this.studentSignatureEmpty = true
          this.$nextTick(() => {
            if (this.$refs.studentSignaturePad) {
              this.$refs.studentSignaturePad.clearSignature()
            }
          })
          await this.init()
        } else {
          this.toggleDialog({
            status: true,
            title: 'Error',
            message: "Something went wrong, feedback wasn't saved"
          })
        }
      }
    },
    async init() {
      const self = this
      const now = new Date()
      let start = new Date(now.getFullYear() - 100, 0, 1)
      let end = new Date(now.getFullYear() + 100, 11, 31)
      const payload = {
        studentId: self.user.id,
        start,
        end,
        limit: self.pageSize,
        skip: 0,
        append: false,
        status: self.status
      }
      try {
        const { hasMore, results, total } = await self.getStudentAppointments(payload)
        if (results && results.length) {
          self.totalAppointmentsCount = total != null ? total : null
          const newMapped = results.map((studentAppointment) => {
            const instructor = studentAppointment.get('instructorId')
            const status = studentAppointment.get('status')
            return {
              appointmentId: studentAppointment.id,
              name: `${instructor.get('firstName')} ${instructor.get('lastName')}`,
              profilePicture: instructor.get('profilePicture') || 'https://thedriverx.com/assets/images/user.png',
              deviceId: instructor.get('deviceId'),
              instructorId: instructor.id,
              instructorEmail: instructor.get('customEmail'),
              phone: instructor.get('phone'),
              type: studentAppointment.get('type'),
              start: new Date(studentAppointment.get('start')),
              end: new Date(studentAppointment.get('end')),
              location: studentAppointment.get('appoinmentLocation'),
              roadtestOptions: studentAppointment.get('roadtestOptions'),
              learningOptions: studentAppointment.get('learningOptions'),
              color: self.getColor(status),
              drivingLessonDates: studentAppointment.get('drivingLessonDates'),
              notes: studentAppointment.get('notes'),
              status,
              hasStudentSignature: !!studentAppointment.get('studentSignature')
            }
          })
          self.appointments = newMapped
          self.hasMore = hasMore === undefined ? false : hasMore
        } else {
          self.appointments = []
          self.hasMore = false
          self.totalAppointmentsCount = 0
        }
      } finally {
        self.loading = false
      }
      await self.getRescheduleFromAdmin({ studentId: self.user.id })
      if (this.rescheduleFromAdmin) {
        self.notifications = self.rescheduleFromAdmin
          ? self.rescheduleFromAdmin.map((reschedule) => {
            const instructor = reschedule.get('instructorId')
            const school = reschedule.get('schoolId')
            if (school) {
              return {
                school: school.get('name'),
                instructor: `${instructor.get('firstName')} ${instructor.get('lastName')}`,
                date: this.$moment(reschedule.get('newDate')).format('LLL')
              }
            }
          })
          : []
      }
    },
    async runSearch () {
      this.loading = true
      await this.init()
    },
    async loadMore () {
      const self = this
      if (self.loadingMore || !self.hasMore || !self.user?.id) return
      self.loadingMore = true
      try {
        const now = new Date()
        let start = new Date(now.getFullYear() - 100, 0, 1)
        let end = new Date(now.getFullYear() + 100, 11, 31)
        const payload = {
          studentId: self.user.id,
          start,
          end,
          limit: self.pageSize,
          skip: self.appointments.length,
          append: true,
          status: self.status
        }
        const { hasMore, results } = await self.getStudentAppointments(payload)
        if (results && results.length) {
          const newMapped = results.map((studentAppointment) => {
            const instructor = studentAppointment.get('instructorId')
            const status = studentAppointment.get('status')
            return {
              appointmentId: studentAppointment.id,
              name: `${instructor.get('firstName')} ${instructor.get('lastName')}`,
              profilePicture: instructor.get('profilePicture') || 'https://thedriverx.com/assets/images/user.png',
              deviceId: instructor.get('deviceId'),
              instructorId: instructor.id,
              instructorEmail: instructor.get('customEmail'),
              phone: instructor.get('phone'),
              type: studentAppointment.get('type'),
              start: new Date(studentAppointment.get('start')),
              end: new Date(studentAppointment.get('end')),
              location: studentAppointment.get('appoinmentLocation'),
              roadtestOptions: studentAppointment.get('roadtestOptions'),
              learningOptions: studentAppointment.get('learningOptions'),
              color: self.getColor(status),
              drivingLessonDates: studentAppointment.get('drivingLessonDates'),
              notes: studentAppointment.get('notes'),
              status,
              hasStudentSignature: !!studentAppointment.get('studentSignature')
            }
          })
          self.appointments = self.appointments.concat(newMapped)
          self.hasMore = hasMore === undefined ? false : hasMore
        } else {
          self.hasMore = false
        }
      } finally {
        self.loadingMore = false
      }
    },
    onScroll (e) {
      if (!['list', 'card'].includes(this.dashboardView) || this.loadingMore || !this.hasMore || !this.user?.id) return
      const el = e?.target
      if (!el || typeof el.scrollHeight === 'undefined') return
      if (el.scrollHeight - el.scrollTop - el.clientHeight > 200) return
      this.loadMore()
    },
    getColor(status) {
      switch (status) {
        case 'Declined':
          return 'red'
        case 'Pending':
          return 'grey'
        case 'Finished':
          return 'success'
        default:
          return 'primary'
      }
    },
    showDialog(e) {
      this.appointment = e.event
      this.dialog = true
    },
    async rescheduleEvent() {
      const self = this
      await self.rescheduleAppointment({
        appointmentId: self.appointment.appointmentId,
        name: self.appointment.name,
        senderName:
          self.user.get('firstName') + ' ' + self.user.get('lastName'),
        date: self.appointment.start,
        email: self.appointment.instructorEmail,
        note: self.rescheduleEventNotes
      })
      if (self.rescheduleAppment) {
        /** send push notification to the student */
        if (typeof self.appointment.deviceId !== 'undefined') {
          await self.sendPushNotification({
            player_id: self.appointment.deviceId,
            message:
              'Your appointment has been rescheduled for ' +
              self.appointment.name,
            type: 'noti',
            senderId: self.user.id,
            name: self.user.get('firstName') + ' ' + self.user.get('lastName')
          })
        }
        await self.init()
        self.toggleDialog({
          status: true,
          title: 'Success',
          message:
            'This appointment has been cancelled and instructor has been notified. You can always book a new appointment.'
        })
        self.appointments = self.appointments.filter(
          (appointment) =>
            self.appointment.appointmentId !== appointment.appointmentId
        )
      } else {
        self.toggleDialog({
          status: true,
          title: 'Error',
          message: 'Something went wrong, please try again.'
        })
      }
      this.confirm = false
      self.dialog = false
      self.appointment = null
    },

    addToCalendar() {
      /** Only on mobile app */
      if (typeof window.cordova !== 'undefined') {
        // prep some variables
        var startDate = new Date(this.appointment.start) // beware: month 0 = january, 11 = december
        var endDate = new Date(this.appointment.end)
        var title = 'DriverX Appointment'
        var eventLocation = this.appointment.location
        var notes = this.appointment.notes

        var success = () => {
          this.toggleDialog({
            status: true,
            title: 'Success',
            message: "This appointment has been sync'd with your calendar"
          })
        }

        var error = () => {
          this.toggleDialog({
            status: true,
            title: 'Error',
            message: 'Something went wrong, please try again.'
          })
        }

        window.plugins.calendar.createEvent(
          title,
          eventLocation,
          notes,
          startDate,
          endDate,
          success,
          error
        )
      }
    }
  },
  async created() {
    await this.init()
  }
}
</script>

<style scoped>
.student-rate-card {
  border-radius: 12px;
  overflow: hidden;
}

.signature-section {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 10px;
  background: #fafafa;
}

.signature-pad-wrapper {
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
}

.student-signature-pad {
  width: 100%;
  height: 140px;
  border: 2px dashed rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  background: #fff;
  touch-action: none;
  display: block;
  position: relative;
}

.student-signature-pad>>>canvas {
  border-radius: 4px;
  width: 100% !important;
  height: 100% !important;
  touch-action: none;
  cursor: crosshair;
  display: block;
}

.feedback-signature-img {
  max-width: 100%;
  max-height: 60px;
  object-fit: contain;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  background: #fff;
}

/* Safe area at top on mobile so content doesn't sit under notch/status bar */
.student-bookings-mobile.rounded {
  padding-top: constant(safe-area-inset-top, 0px);
  padding-top: env(safe-area-inset-top, 0px);
  height: calc(100vh - 88px - constant(safe-area-inset-top, 0px)) !important;
  height: calc(100vh - 88px - env(safe-area-inset-top, 0px)) !important;
}
</style>
